<template>
  <div class="main">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>微信管理</el-breadcrumb-item>
      <el-breadcrumb-item>微餐饮</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="tab">
        <div :class="item.value==acindex?'active':''" v-for="(item,index) in tab" :key="index" @click="tabClick(item.value)">{{ item.label }}</div>
    </div>
    <div class="center_table" v-if="acindex==1">
        <div class="top">
          <div class="input_div">
            <div @click="add">添加餐厅</div>
          </div>
        </div>
       
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column   label="排序" width="100">
            <template slot-scope="scope">
              <div class="paixu">
                <el-input v-model="scope.row.sort" @blur="sortBlur(scope.row)" ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="餐厅名称" ></el-table-column>
          <el-table-column prop="ReturnFlag" label="店铺状态" >
            <template  slot-scope="scope">
              <el-switch
                v-model="scope.row.states"
                @change="changes(scope.row,$event)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="下单模式" >
            <template  slot-scope="scope">
               <div>
                <span>{{scope.row.method=='0'?'餐桌点餐':'叫号点餐'}}</span>
               </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="餐厅状态" >
            <template  slot-scope="scope">
               <div>
                <span>{{scope.row.state=='0'?'下线':scope.row.state=='1'?"上线":'删除'}}</span>
               </div>
            </template>
          </el-table-column>
          <el-table-column  label="操作" width="200"    fixed="right">
            <template slot-scope="scope">
              <div class="caozuo">
                <span @click="dishClick('1',scope.row)">菜品授权</span>
                <span @click="add('2',scope.row)">编辑</span>
                <span class="tab_del" @click="restDeta(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="acindex==2">
        <div class="top">
          <div class="input_div">
            <div @click="opening">添加档口</div>
          </div>
          <!-- <div class="right_btn">
              <div>删除</div>
          </div> -->
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column prop="stall" label="档口名称" ></el-table-column>
          <el-table-column prop="createtime" label="添加时间" ></el-table-column>
          <el-table-column  label="操作" width="200"    fixed="right">
            <template slot-scope="scope">
              <div class="caozuo">
                <!-- <span  @click="dishClick('2')">菜品授权</span> -->
                <span @click="opening(scope.row)">编辑</span>
                <!-- <span class="tab_del" @click="OpenDete(scope.row)">删除</span> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="currenchange2" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="acindex==3">
        <div class="top">
          <div class="input_div">
            <div @click="addType">添加类别</div>
          </div>
          <!-- <div class="right_btn">
              <div>删除</div>
          </div> -->
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column   label="排序" width="300">
            <template slot-scope="scope">
              <div class="paixu">
                <el-input v-model="scope.row.sort" @blur="sortBlur1(scope.row)" ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="类别名称" width="600"></el-table-column>
          <el-table-column prop="state" label="分类状态" width="500">
            <template  slot-scope="scope">
              <el-switch
                v-model="scope.row.states"
                @change="change1(scope.row,$event)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column  label="操作"    fixed="right">
            <template slot-scope="scope">
              <div class="caozuo">
                <span @click="addType(scope.row)">编辑</span>
                <span class="tab_del" @click="TypeDete(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="currenchange3" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="acindex==4">
        <div class="top">
          <div class="input_condition">
            <el-select v-model="data1.classname" placeholder="全部分类" clearable>
              <el-option
                v-for="item in optionType"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
            <div class="btnen" @click="typeClick">查询</div>
          </div>
          <div class="right_btn">
              <div @click="addVar">添加菜品</div>
              <!-- <div>删除</div> -->
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column   label="排序" width="100">
            <template slot-scope="scope">
              <div class="paixu">
                <el-input v-model="scope.row.sort" @blur="sortBlur2(scope.row)" ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="菜名" ></el-table-column>
          <el-table-column prop="price" label="商品单价" ></el-table-column>
          <el-table-column prop="classname" label="商品分类" ></el-table-column>
          <el-table-column prop="daylimitnum" label="日库存" ></el-table-column>
          <el-table-column prop="orderlimitnum" label="每单限购" ></el-table-column>
          <el-table-column p label="限购日期" width="200">
            <template slot-scope="scope">
              {{scope.row.consumebegindate}}--{{scope.row.consumeenddate}}
            </template>
          </el-table-column>
          <el-table-column prop="businesstime" label="限购时间" ></el-table-column>
          <el-table-column prop="stallname" label="档口名称" ></el-table-column>
          <el-table-column prop="ReturnFlag" label="使用状态" width="80">
            <template  slot-scope="scope">
              <el-switch
                v-model="scope.row.states"
                @change="change2(scope.row,$event)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column  label="操作" width="200"    fixed="right">
            <template slot-scope="scope">
              <div class="caozuo">
                <span @click="addVar(scope.row)">编辑</span>
                <span class="tab_del" @click="DetaVar(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data1.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data1.page_size" :total="total" :current-page="data1.page"  @current-change="currenchange4" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="acindex==5">
        <div class="top">
          <div class="input_condition">
            <!-- <el-select v-model="data2.restaurantid" placeholder="选择餐厅" clearable>
              <el-option
                v-for="item in reOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select> -->
            <!-- <div class="" >查询</div> -->
            <div :class="data2.restaurantid==item.id?'restClass':'btn'" @click="restClick(item)" v-for="(item,index) in reOption" :key="index">
              {{item.name}}
            </div>
          </div>
          <div class="right_btn">
              <div @click="addspace('1')" v-if="method==0">添加桌位</div>
              <!-- <div>删除</div> -->
          </div>
        </div>
        <div v-if="method==0">
          <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column   label="排序" width="400">
            <template slot-scope="scope">
              <div class="paixu">
                <el-input v-model="scope.row.sort" @blur="sortBlur5(scope.row)" ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="餐桌编号"  width="500">
          </el-table-column>
          <el-table-column  label="桌位二维码"  width="550">
            <template  slot-scope="scope">
              <div class="dateFlex indicating" @click="addspace('2',scope.row)">
                <img src="@/images/scenic/ma.png" alt="">
                <span>查看二维码</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="操作"   fixed="right" >
            <template slot-scope="scope">
              <div class="caozuo">
                <span @click="addspace('1',scope.row)">编辑</span>
                <span class="tab_del" @click="spaceClick(scope.row)">删除</span>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <div class="pagination">
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{data2.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="data2.page_size" :total="total" :current-page="data2.page"  @current-change="currenchange5" ></el-pagination>
          </div>
        </div>
        <div v-if="method==1" class="methodsFlex">
          <span style="font-size:1.8rem;">下单模式：叫号点餐</span>
          <img :src="erweima" alt="" v-if="erweima!=''">
        </div>
    </div>
    <div class="center_form" v-if="acindex==6">
        <el-form label-width="120px">
          <el-form-item label="小程序APPid：">
            <el-input v-model="Appid"></el-input>
          </el-form-item>
          <el-form-item label="小程序secrect：">
            <el-input  v-model="secrect"></el-input>
          </el-form-item>
          <el-form-item label="分销商appid：">
            <el-input  v-model="jfyappid"></el-input>
          </el-form-item>
        </el-form>
        <div class="form_btns">
            <div @click="configuration">重置</div>
            <div @click="configClick">确认保存</div>
        </div>
    </div>
    <div class="center_table" v-if="acindex==7">
        <div class="top">
          <div class="input_condition">
            <el-input v-model="data3.OrderNumber" placeholder="订单号"></el-input>
            <span style="margin:0 0.5rem 0 0;">日期：</span>
            <el-date-picker
              v-model="valueTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-select v-model="data3.restaurantid" placeholder="选择餐厅" clearable>
              <el-option
                v-for="item in reOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <div class="btn orderbtns" @click="ClickBtns">查询</div>
            <div class="btn exportBnts orderbtns" @click="exporBtns">导出报表</div>
          </div>
          <div class="right_btn">
          </div>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
        >
          <el-table-column prop="ordernumber" label="餐饮订单号" ></el-table-column>
          <el-table-column prop="rname" label="餐厅名称" ></el-table-column>
          <el-table-column prop="foodname" label="菜品名称" ></el-table-column>
          <el-table-column prop="money" label="订单金额" ></el-table-column>
          <el-table-column prop="datetime" label="下单时间" ></el-table-column>
          <el-table-column  label="操作" width="200"   fixed="right">
            <template slot-scope="scope">
              <div class="caozuo">
                <span @click="tuikuan(scope.row)">订单退款</span>
                <span @click="orderDetail(scope.row)">订单详情</span>
                <span class="tab_del"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data3.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data3.page_size" :total="total" :current-page="data3.page"  @current-change="currenchange7" ></el-pagination>
        </div>
    </div>
    <div class="center_table" v-if="acindex==8">
      <el-select v-model="uid" placeholder="全部餐厅" clearable @change="connectSocket()">
        <el-option
          v-for="item in orderOtion"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <div v-for="(item,index) in content" :key="index" style="margin-top:1rem;font-size:1.6rem;">
        {{item.text}}
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addFlow"
      :before-close="addProHandleClose"
      width="960px"
      center
    >
        <div class="restaurant">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForma" label-width="120px" class="demo-ruleForm">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="ruleForm.name" maxlength="15" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="餐具价格：" >
              <el-input v-model="ruleForm.tableware"   @blur="limitNumbersEvent" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="营业时间：" >
              <div class="names_times" v-for="(item,index) in timeOption" :key="index">
                  <el-time-picker
                    is-range
                    @change="changeStar(index)"
                    v-model="item.time"
                    range-separator="至"
                    value-format="HH:mm"
                    format="HH:mm"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    placeholder="选择时间范围"
                  ></el-time-picker>
                 <img class="imgs_times" src="@/assets/addpro.png" alt="" v-if="index+1==timeOption.length" @click="addSonpro">
                 <img  class="imgs_times" src="@/assets/jianpro.png" alt="" v-if="index>0" @click="reduce(index)">
              </div>
            </el-form-item>
            <el-form-item label="营业日期：">
                <div class="dateFlex">
                  <el-checkbox v-model="checkAll" @change="yesChange">每日</el-checkbox>
                  <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                  </el-checkbox-group>
                </div>
            </el-form-item>
            <el-form-item label="上传图片：" prop="pic">
              <!-- <el-upload
                class="avatar-uploader"
                action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                :show-file-list="false"    
                :on-success="attachUploadSuccess"
                :data="datas"
                >
                <img v-if="ruleForm.pic" :src="ruleForm.pic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload> -->
              <div class="flexs_upload">
                    <cutImageDialog ref="place" :imgs="ruleForm.pic" @resurl="resurl" v-if="flag"  />
              </div>  
            </el-form-item>
            <el-form-item label="描述：" prop="info">
              <div class="mask_notes"> 
                <el-input type="textarea" maxlength="50" v-model="ruleForm.info" placeholder="--"></el-input>
              </div>
            </el-form-item>
            <div class="dateFlex">
              <el-form-item label="状态：">
                <el-select v-model="ruleForm.state" placeholder="请选择">
                  <el-option
                    v-for="item in option1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单模式：" prop="method">
                <el-select v-model="ruleForm.method" placeholder="请选择">
                  <el-option
                    v-for="item in option2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-form-item label="关键词类型：">
              <el-radio v-model="ruleForm.notice_type" label="1">不通知</el-radio>
              <el-radio v-model="ruleForm.notice_type" label="2">通知</el-radio>   
              <span style="color: #E74C3C;">注：选择通知，会由档口发送短信通知用户到相应档口取餐！</span>  
            </el-form-item>
          </el-form>
          <div class="addBtns">
              <div @click="closeClick">重置</div>
              <div @click="addBtnsClic('ruleForma')">确认</div>
          </div>
        </div>
    </el-dialog>
    <dish v-if="dishFlow" ref="addDialog" @Close='dishClose'></dish>
    <addopen v-if="openFlow" :option="reOption" ref="addOpen" @close='openClose'></addopen>
    <category v-if="cateFlow" ref="cate" @close="cateClose"></category>
    <addvariety v-if="varietyFlow" ref="variety" @close="varietyClose"></addvariety>
    <space v-if="spaceFlow" :restaurantid='data2.restaurantid' ref="space" @close="spaceClose"></space>
    <order v-if="orderFlow" ref="orde" @close="orderClose"></order>
  </div>
</template>
<script>
  import dish from './dialog/dish.vue'
  import addopen from './dialog/addOpen.vue'
  import category from './dialog/category.vue'
  import addvariety from './dialog/addvariety.vue'
  import space from './dialog/space.vue'
  import order from './dialog/order.vue'
  import {RestaurantList,RestaurantAdd,RestaurantUpdate,
    StallList,ClassList,MenuList,ClassUpdate,
    StallDelete,SysFirst,SysAdd,SysUpdate,
    MenuUpdate,WftableList,WftableUpdate,
    WforderList,WforderExport,WforderRefund,WfcodeList,WftableGetCode , orderscreen} from '@/request/scenic.js'
  import {Message,MessageBox} from "element-ui"
  import cutImageDialog from '@/assets/place.vue'
  const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
import VueSocketIO from 'vue-socket.io'
  export default{
    components:{
      dish,
      addopen,
      category,
      addvariety,
      space,
      order,cutImageDialog 
    },
    data(){
      return{
        flag:false,
        orderOtion:[],
        acindex:1,
        tab:[
          {
            value:'1',
            label:'餐厅管理'
          },
          {
            value:'2',
            label:'档口管理'
          },
          {
            value:'3',
            label:'分类管理'
          }, 
          {
            value:'4',
            label:'菜品管理'
          }, 
          {
            value:'5',
            label:'桌位管理'
          }, 
          {
            value:'6',
            label:'密钥配置'
          }, 
          {
            value:'7',
            label:'订单列表'
          }, 
          {
            value:'8',
            label:'订单大屏'
          }
        ],
        option:[
          {
            value:'1',
            label:'xxx'
          }
        ],
        tableData:[
        ],
        addFlow:false,
        titleType:'添加餐厅',
        ruleForm: {
          token:window.sessionStorage.getItem('Token'),
          name: '',
          pic:'',
          state:'1',
          info:'',
          method:'',
          notice_type:'1',
          tableware:'',
          starttime:'00:00:00',
          stoptime:'23:59:59',
          type:'m'
        },
        timeOption:[{
          time:['00:00','23:59']
        },
        ],
        rules: {
          name: [
            { required: true, message: '请输入', trigger: 'blur' },
          ],
          pic: [{ required: true, message: '请上传图片', trigger: 'change'}],
          method:[{ required: true, message: '请选择下单模式', trigger: 'change'}],
          info:[{ required: true, message: '请输入', trigger: 'blur' }]
        },
        dishFlow:false,
        checkedCities: ['星期一','星期二','星期三','星期四','星期五','星期六','星期日',],
        cities: cityOptions,
        isIndeterminate:true,
        yesChangeFlow:false,
        checkAll:true,
        value1:'',
        value2:'',
        imageUrl:'',
        option1:[
          {
            value:'0',
            label:'下线'
          },
          {
            value:'1',
            label:'上线'
          }
        ],
        option2:[
          {
            value:'0',
            label:'餐桌点餐'
          },
          {
            value:'1',
            label:'叫号点餐'
          }
        ],
        radio:'1',
        openFlow:false,
        value:'',
        cateFlow:false,
        varietyFlow:false,
        spaceFlow:false,
        orderFlow:false,
        data:{
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:10
        },
        total:0,
        RestaurantId:'',
        datas:{
          token:window.sessionStorage.getItem('Token')
        },
        Appid:'',
        secrect:'',
        configId:'',
        jfyappid:'',
        data1:{
          token:window.sessionStorage.getItem('Token'),
          classname:'',
          page:1,
          page_size:10
        },
        data2:{
          token:window.sessionStorage.getItem('Token'),
          restaurantid:'',
          page:1,
          page_size:10
        },
        optionType:[],
        reOption:[],
        app:'',
        data3:{
          token:window.sessionStorage.getItem('Token'),
          OrderNumber:'',
          ValidBeginDate:'',
          ValidEndDate:'',
          restaurantid:'',
          id:'',
          page_size:10,
          page:1
        },
        valueTime:'',
        method:'',
        erweima:'',
        message:'',
        uid:'',
        content:[]
      }
    },
    mounted(){
   
    },
    created(){
      this.getList('1')
      let data = {
          page:1,
          page_size:999,
          token:window.sessionStorage.getItem('Token')
      }
      let ad = {
        token:window.sessionStorage.getItem('Token')
      }
      ClassList(data).then(res=>{
        if(res.data.status=='ok'){
          this.optionType = []
          res.data.result.data.map(item=>{
            if(item.state=='1'){
              this.optionType.push(item)
            }
          })
        }
      })
      SysFirst(ad).then(res=>{
        if(res.data.result!=null){
          this.app = res.data.result.xappid
        }
      })
    },
    methods:{
      limitNumbersEvent(e) {
        // 通过正则保留两位小数点
        let val = e.target.value
        if (val.length > 6) val = val.slice(0, 6)
        e.target.value = (val.match(/^\d*(\.?\d{0,2})/g)[0]) || null
      },
      resurl(row){
        this.ruleForm.pic = row
      },
      getPinList(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
        }
        orderscreen(data).then(res=>{
          if(res.data.status=='ok'){
            this.orderOtion = res.data.result
            this.uid = res.data.result[0].id
            this.connectSocket();
          }
        })
      },
      connectSocket() {
        this.content = []
        let uid = window.sessionStorage.getItem('ScenicId')+ 'softykt' + this.uid
        // 连接到socket.io服务器
        let socket = io('http://home.softykt.net'+':2120');
        socket.on('connect', function(){
            socket.emit('login', uid );
        });
        // 监听服务器发送的事件
        socket.on('new_msg', (data) => {
          console.log('Connected to the socket server',data);
        });
        socket.on('new_order', (data) => {
          console.log('Received data from server:', data);
          this.content.unshift({
            text:data.content
          })
        });
        // 注意：这里不包含消息推送的代码
      },  
     
      reduce(index){
        this.timeOption.splice(index,1)
      },
      addSonpro(){
        if(this.timeOption.length==4){
          Message.error('营业时间最多添加四个')
          return false
        }
        this.timeOption.push({
          time:['00:00','23:59']
        })
      },
      changeStar(index){
        this.ruleForm.type = 'r'
        console.log()
        if(index==0){
          return false
        }else{
          if(this.time_to_sec(this.timeOption[index-1].time[0])<this.time_to_sec(this.timeOption[index].time[0])){
            
          }else{
            Message.error('请选择相比于上一个时间段更晚一点的营业时间')
            this.timeOption[index].time = ''
            return false
          }
        }
      },
      time_to_sec(time) {
          if (time !== null) {
              var s = "";
              var hour = time.split(":")[0];
              var min = time.split(":")[1];
              s = Number(hour * 3600) + Number(min * 60) ;
              return s;
          }
      },
      timeChage(){
        this.ruleForm.type = 'r'
      },
      changes(row,e){
        MessageBox('此操作将修改餐厅状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let stats = ''
          if(e){
            stats = 1
          }else{
            stats = 0
          }
          let data = row
          data.token=window.sessionStorage.getItem('Token')
          row.state = stats
          let time = ''
          let end = ''
          data.time.map(item=>{
            time = item.starttime + ','
            end = item.stoptime + ','
          })
          if(time.length>0){
            time  = time.substr(0,time.length - 1);
            end  = end.substr(0,end.length - 1);
          }
          data.starttime = time
          data.stoptime = end
          RestaurantUpdate(data).then(res=>{
            if(res.data.status=='ok'){
                Message.success('操作成功')
                this.getList('1')
              }else{
                Message.error(res.data.msg)
              }
          })
        }).catch(() => {
                 
        });
          
      },
      change2(row,e){
        let stats = ''
        if(e){
          stats = 1
        }else{
          stats = 0
        }
        let data = row
        data.token=window.sessionStorage.getItem('Token')
        row.state = stats
        let starttime = []
          let stoptime	= []
          data.times.map(item=>{
            starttime.push(item.starttime)
            stoptime.push(item.stoptime)
          })
          data.starttime = starttime
          data.stoptime =  stoptime
        MenuUpdate(data).then(res=>{
          if(res.data.status=='ok'){
              this.getList('4')
              Message.success('操作成功')
            }else{
              Message.error(res.data.msg)
            }
        })
      },
      change1(row,e){
        let stats = ''
        if(e){
          stats = 1
        }else{
          stats = 0
        }
        let data = row
        data.token=window.sessionStorage.getItem('Token')
        row.state = stats
        ClassUpdate(data).then(res=>{
          if(res.data.status=='ok'){
            this.data.page = 1
            Message.success('操作成功')
            this.getList('3')
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      sortBlur(row){
        let data = row
        data.token=window.sessionStorage.getItem('Token'),
        RestaurantUpdate(data).then(res=>{
          if(res.data.status=='ok'){
              this.data.page = 1
              Message.success('排序成功')
              this.getList('1')
            }else{
              Message.error(res.data.msg)
            }
        })
      },  
      sortBlur1(row){
        let data = row
        data.token=window.sessionStorage.getItem('Token'),
        ClassUpdate(data).then(res=>{
          if(res.data.status=='ok'){
            this.data.page = 1
            Message.success('排序成功')
            this.getList('3')
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      sortBlur2(row){
        let data = row
        data.token=window.sessionStorage.getItem('Token')
        let starttime = []
          let stoptime	= []
          data.times.map(item=>{
            starttime.push(item.starttime)
            stoptime.push(item.stoptime)
          })
          data.starttime = starttime
          data.stoptime =  stoptime
        MenuUpdate(data).then(res=>{
          if(res.data.status=='ok'){
              this.data1.page = 1
              this.getList('4')
              Message.success('排序成功')
            }else{
              Message.error(res.data.msg)
            }
        })
      },
      sortBlur5(row){
        let data = row
        data.token=window.sessionStorage.getItem('Token')
        WftableUpdate(data).then(res=>{
          if(res.data.status=='ok'){
              this.data2.page = 1
              this.getList('5')
              Message.success('排序成功')
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      // 订单退款
      tuikuan(row){
        MessageBox('此操作将退款该订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = {
              id:row.id,
              token:window.sessionStorage.getItem('Token')
            }
            WforderRefund(data).then(res=>{
              console.log(res)
              if(res.data.result!=false){
                Message.success('退款成功')
              }else{
                Message.error(res.data.msg)
              }
            })
        }).catch(() => {
                 
        });
      },
      // 订单导出
      exporBtns(){
        if(this.valueTime){
          this.data3.ValidBeginDate = this.valueTime[0]
          this.data3.ValidEndDate = this.valueTime[1]
        }else{
          this.data3.ValidBeginDate = ''
          this.data3.ValidEndDate = ''
        }
        let data = {
          token:window.sessionStorage.getItem('Token'),
          OrderNumber:this.data3.OrderNumber,
          ValidBeginDate:this.data3.ValidBeginDate,
          ValidEndDate:this.data3.ValidEndDate,
          restaurantid:this.data3.restaurantid,
          id:this.data3.id,
        }
        WforderExport(data).then(res=>{
          if(res.data.result!=false){
            window.location.href = res.data.result
          }else{
            Message.error(res.data.msg)
          }
        })
      },
      // 订单查询
      ClickBtns(){
        if(this.valueTime){
          this.data3.ValidBeginDate = this.valueTime[0]
          this.data3.ValidEndDate = this.valueTime[1]
        }else{
          this.data3.ValidBeginDate = ''
          this.data3.ValidEndDate = ''
        }
        this.data3.page = 1
        this.getList('7')
      },
      // 桌位删除
      spaceClick(row){
        MessageBox('此操作删除该桌位, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = row
            data.state = 3
            data.token = window.sessionStorage.getItem('Token')
            WftableUpdate(data).then(res=>{
              if(res.data.status=='ok'){
                Message.success('删除成功')
                this.data2.page = 1
                this.getList('5')
              }
            })
        }).catch(() => {
                 
        });
      },
      currenchange5(e){
        this.data2.page = e 
        this.getList('5')
      },
      // 菜品查询
      typeClick(){
        this.data1.page = 1
        this.getList('4')
      },
      //桌位餐厅查询
      restClick(item){
        this.method = item.method
        this.data2.restaurantid = item.id
        this.data2.page = 1
        this.getList('5')
        if(this.method==1){
            let da = {
              rid:item.id,
              token:window.sessionStorage.getItem('Token')
            }
            WfcodeList(da).then(res=>{
              if(res.data.status=='ok'){
                if(res.data.result!=null){
                  this.erweima = res.data.result.img_url
                }else{
                  console.log(123)
                  let index = ''
                  if(this.method=='0'){
                    index = 2
                  }else{
                    index = 1
                  }
                  let data = {
                    restaurantid:this.data2.restaurantid,
                    id:0,
                    method:index,
                    token:window.sessionStorage.getItem('Token')
                  }
                  WftableGetCode(data).then(res=>{
                    if(res.data.status=='ok'){
                      this.erweima = res.data.result
                    }
                  })
                }
              }
            })
        }
      },
      // 配置确认
      configClick(){
        if(this.configId){
          let data = {
            token:window.sessionStorage.getItem('Token'),
            xappid:this.Appid,
            secrect:this.secrect,
            jfyappid:this.jfyappid,
            id:this.configId
          }
          SysUpdate(data).then(res=>{
            console.log(res)
            if(res.data.status=='ok'){
              Message.success('密钥配置修改成功')
              this.getList('6')
            }else{
              Message.error(res.data.msg)
            }
          })
        }else{
          let data = {
            token:window.sessionStorage.getItem('Token'),
            xappid:this.Appid,
            secrect:this.secrect,
            jfyappid:this.jfyappid
          }
          SysAdd(data).then(res=>{
            if(res.data.status=='ok'){
              Message.success('密钥配置添加成功')
              this.getList('6')
            }else{
              Message.error(res.data.msg)
            }
          })
        }
      },
      // 配置重置
      configuration(){
        this.Appid = ''
        this.secrect = ''
      },
      // 菜品删除
      DetaVar(row){
        MessageBox('此操作删除该菜品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = row
          data.token = window.sessionStorage.getItem('Token')
          data.state = '3'
          let starttime = []
          let stoptime	= []
          data.times.map(item=>{
            starttime.push(item.starttime)
            stoptime.push(item.stoptime)
          })
          data.starttime = starttime
          data.stoptime =  stoptime
          MenuUpdate(data).then(res=>{
            if(res.data.status=='ok'){
              this.data1.page = 1
              this.getList('4')
              Message.success('删除成功')
            }else{
              Message.error(res.data.msg)
            }
          })
        }).catch(() => {
                 
        });
      },
      // 档口删除
      OpenDete(row){
        MessageBox('此操作删除该档口, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            id:row.id
          }
          StallDelete(data).then(res=>{
            if(res.data.status=='ok'){
              this.data.page = 1
              this.getList('2')
              Message.success('删除成功')
            }else{
              Message.error(res.data.msg)
            }
          })
        }).catch(() => {
                 
        });
      },
      // 分类删除
      TypeDete(row){
        MessageBox('此操作删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            token:window.sessionStorage.getItem('Token'),
            name:row.name,
            state: '3',
            sort:row.sort,
            id:row.id
          }
          ClassUpdate(data).then(res=>{
            if(res.data.status=='ok'){
              this.data.page = 1
              Message.success('删除成功')
              this.getList('3')
            }else{
              Message.error(res.data.msg)
            }
          })
        }).catch(() => {
                 
        });
      },
      // 餐厅删除
      restDeta(row){
        MessageBox('此操作删除该餐厅, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let data = {
              token:window.sessionStorage.getItem('Token'),
              name: row.name,
              pic:row.pic,
              state: '3',
              info:row.info,
              method:row.method + '',
              notice_type:row.notice_type + '',
              tableware:row.tableware,
              id:row.id
            }
            RestaurantUpdate(data).then(res=>{
              if(res.data.status=='ok'){
                  this.data.page = 1
                  Message.success('删除成功')
                  this.getList('1')
                }else{
                  Message.error(res.data.msg)
                }
            })
        }).catch(() => {
                 
        });
        
      },
      attachUploadSuccess(response){
        this.ruleForm.pic = response.result
      },
      addBtnsClic(ruleForma){
        var arr = []
        if(this.checkedCities.length!=0){
          this.checkedCities.map(item=>{
            switch(item){
              case '星期一':
                arr += '1' + ','
                break;
              case '星期二':
                arr += '2' + ','
                break;
              case '星期三':
                arr += '3' + ','
                break;
              case '星期四':
                arr += '4' + ','
                break;
              case '星期五':
                arr += '5' + ','
                break;
              case '星期六':
                arr += '6' + ','
                break;
              case '星期日':
                arr += '7' + ','
                break;
              default:
              // body of default
            }
          })
        }
        if (arr.length > 0) {
          arr  = arr.substr(0,arr.length - 1);
        }
        this.$refs.ruleForma.validate((valid) => {
          if (valid) {
            this.ruleForm.weeks = arr
            let time = ''
            let end  = ''
            this.timeOption.map(item=>{
              time += item.time[0] + ','
              end += item.time[1] + ','
            })
            if(time.length>0){
              time  = time.substr(0,time.length - 1);
              end  = end.substr(0,end.length - 1);
            }
            let form = this.ruleForm
            form.starttime = time
            form.stoptime = end
            form.type = 'r'
            if(this.RestaurantId){
              this.ruleForm.id = this.RestaurantId
              RestaurantUpdate(form).then(res=>{
                if(res.data.rcode=='200'){
                  this.addFlow = false
                  Message.success('修改成功')
                  this.RestaurantId = ''
                  this.getList('1')
                  this.ruleForm =  {
                    token:window.sessionStorage.getItem('Token'),
                    name: '',
                    pic:'',
                    state:'',
                    info:'',
                    method:'',
                    notice_type:'1',
                    tableware:''
                  }
                }else{
                  Message.error(res.data.msg)
                  this.ruleForm.starttime = ''
                  this.ruleForm.stoptime =''
                }
              })
            }else{
              RestaurantAdd(form).then(res=>{
                if(res.data.rcode=='200'){
                  this.addFlow = false
                  Message.success('添加成功')
                  this.getList('1')
                  this.ruleForm =  {
                    token:window.sessionStorage.getItem('Token'),
                    name: '',
                    pic:'',
                    state:'',
                    info:'',
                    method:'',
                    notice_type:'1',
                    tableware:''
                  }
                }else{
                  Message.error(res.data.msg)
                  this.ruleForm.starttime = ''
                  this.ruleForm.stoptime =''
                }
            })
            }
            this.flag = false
          } else {
            return false
          }
        })
      },
      currenchange7(e){
        this.data3.page = e
        this.getList('7')
      },
      currenchange(e){
        this.data.page = e
        this.getList('1')
      },
      currenchange2(e){
        this.data.page = e
        this.getList('2')
      },
      currenchange3(e){
        this.data.page = e
        this.getList('3')
      },
      currenchange4(e){
        this.data1.page = e
        this.getList('4')
      },
      getList(e){
        switch(e){
          case '1':
              ///
              RestaurantList(this.data).then(res=>{
                if(res.data.status=='yes'){
                  this.tableData = res.data.data.data
                  this.total  = res.data.data.total
                  this.reOption = res.data.data.data
                  if(res.data.data.data.length!=0){
                    this.data2.restaurantid = res.data.data.data[0].id
                    this.method = res.data.data.data[0].method
                  }
                  this.tableData.map(item=>{
                    if(item.state=='1'){
                      item.states = true
                    }else{
                      item.states = false
                    }
                  })
                }
              })
            break;
          case '2':
              StallList(this.data).then(res=>{
                if(res.data.status=='ok'){
                  this.tableData = res.data.result.data
                  this.total  = res.data.result.total
                }
              })
            break;
          case '3':
              ClassList(this.data).then(res=>{
                if(res.data.status=='ok'){
                  this.tableData = res.data.result.data
                  this.total  = res.data.result.total
                  this.tableData.map(item=>{
                    if(item.state=='1'){
                      item.states = true
                    }else{
                      item.states = false
                    }
                  })
                }
              })
            break;
          case '4':
              MenuList(this.data1).then(res=>{
                if(res.data.status=='ok'){
                  this.tableData = res.data.result.data
                  this.total  = res.data.result.total
                  this.tableData.map(item=>{
                    if(item.state=='1'){
                      item.states = true
                    }else{
                      item.states = false
                    }
                  })
                }
              })
            break;
          case '5':
              WftableList(this.data2).then(res=>{
                if(res.data.status=='ok'){
                  this.tableData = res.data.result.data
                  this.total  = res.data.result.total
                }
              })
            break;
          case '6':
              SysFirst(this.data).then(res=>{
                if(res.data.status=='ok'){
                  if(res.data.result!=null){
                    this.Appid = res.data.result.xappid
                    this.secrect = res.data.result.secrect
                    this.configId = res.data.result.id
                    this.jfyappid = res.data.result.jfyappid
                  }
                }
              })
            break;
          case '7':
              WforderList(this.data3).then(res=>{
                if(res.data.status=='ok'){
                  this.tableData = res.data.result.data
                  this.total  = res.data.result.total
                }
              })
            break;
          default:
          // body of default
        }
      },
      orderClose(){
        this.orderFlow = false
      },
      orderDetail(row){
        this.orderFlow = true
        this.$nextTick(() => {
            this.$refs.orde.pxFn(row);
        });
      },
      spaceClose(){
        this.getList('5')
        this.spaceFlow = false
      },
      // 添加桌位
      addspace(e,row){
        if(this.app==''){
          Message.error('请先设置密钥')
          return false
        }
        let ids = ''
        this.reOption.map(item=>{
          if(item.id==this.data2.restaurantid){
              if(item.method=='1'){
                ids = 1
              }else{
                ids = 2
              }
          }
        })
        this.spaceFlow = true
        this.$nextTick(() => {
            this.$refs.space.pxFn(e,row,ids);
        });
      },
      // 关闭菜品
      varietyClose(e){
        if(e==1){
          this.tabClick(1)
        }else{
          this.getList('4')
        }
        this.varietyFlow = false
      },
      // 添加菜品
      addVar(row){
        this.varietyFlow = true
        this.$nextTick(() => {
            this.$refs.variety.pxFn(row);
        });
      },
      // 关闭类别
      cateClose(){
        this.cateFlow = false
        this.data.page = 1
        this.getList('3')
      },
      // 添加类别
      addType(row){
        this.cateFlow = true
        this.$nextTick(() => {
          this.$refs.cate.pxFn(row);
        });
      },
      // 添加档口
      opening(row){
        if(this.reOption.length==0){
          Message.error('请先添加餐厅')
          return false
        }
        this.openFlow = true
        this.$nextTick(() => {
          this.$refs.addOpen.pxFn(row);
        });
      },
      //关闭添加档口
      openClose(){
        this.data.page = 1
        this.getList('2')
        this.openFlow = false
      },
      // tab切换
      tabClick(e){
        this.tableData = []
        this.data.page = 1
        this.total = 0
        this.acindex = e
        if(e=='1'){
          this.getList('1')
        }else if(e=='2'){
          this.getList('2')
        }else if(e=='3'){
          this.getList('3')
        }else if(e=='4'){
          this.getList('4')
        }else if(e=='5'){
          this.getList('5')
          this.restClick(this.reOption[0])
        }else if(e=='6'){
          this.getList('6')
        }else if(e=='7'){
          this.getList('7')
        }else{
          this.content = []
          this.getPinList()
        }
        
      },
      yesChange(e){
        if(this.yesChangeFlow==false){
          this.$nextTick(function(){
            this.checkAll = true
            this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
            this.yesChangeFlow=true
          })
        }
        if(e){
          this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
        }else{
          this.checkedCities = []
        }
      },
      handleCheckedCitiesChange(value) {
        if(value.length==7){
          this.checkAll = true
        }
        let checkedCount = value.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.cities.length;
      },
      // 餐厅档口授权
      dishClick(e,list){
        let row = {
          index:e,
          data:list
        }
        this.dishFlow = true
        this.$nextTick(() => {
          this.$refs.addDialog.pxFn(row);
        });
      },
      // 关闭餐厅档口授权
      dishClose(){
        this.dishFlow = false
      },
      // 餐厅添加商品
      add(e,row){
        if(e==2){
          this.titleType = '餐厅详情'
          this.RestaurantId = row.id
          if(e.weeks){
            e.weeks.split(',').map(item=>{
              switch(item){
                case '1':
                  this.checkedCities.push('星期一')
                  break;
                case '2':
                  this.checkedCities.push('星期二')
                  break;
                case '3':
                  this.checkedCities.push('星期三')
                  break;
                case '4':
                  this.checkedCities.push('星期四')
                  break;
                case '5':
                  this.checkedCities.push('星期五')
                  break;
                case '6':
                  this.checkedCities.push('星期l六')
                  break;
                case '7':
                  this.checkedCities.push('星期日')
                  break;
                default:
                // body of default
              }
            })
          }
          this.ruleForm = {
            token:window.sessionStorage.getItem('Token'),
            name: row.name,
            pic:row.pic,
            state:row.state + '',
            info:row.info,
            method:row.method + '',
            notice_type:row.notice_type + '',
            tableware:row.tableware,
            starttime:'',
            stoptime:'',
            type:'r'
          }
          this.flag = true  
          this.timeOption = []
          if(row.time.length==0){
            this.timeOption = [{
              time:''
            },]
          }else{
            row.time.map(item=>{
              this.timeOption.push({
                time:[item.starttime,item.stoptime]
              })
            })
          }
        }else{
          this.titleType = '添加餐厅'
          this.RestaurantId = ''
          this.ruleForm =  {
            token:window.sessionStorage.getItem('Token'),
            name: '',
            pic:'',
            state:'1',
            info:'',
            method:'',
            notice_type:'1',
            tableware:'',
            starttime:'',
            stoptime:'',
            type:'m'
          }
          this.flag = true  
          this.timeOption  = [{
            time:['00:00','23:59']
          }]
        }
        this.addFlow = true
      },
      closeClick(){
        this.ruleForm =  {
          token:window.sessionStorage.getItem('Token'),
          name: '',
          pic:'',
          state:'1',
          info:'',
          method:'',
          notice_type:'1',
          tableware:'',
          starttime:'',
          stoptime:'',
          type:'m'
        }
        this.$refs.place.list('closess')
        this.timeOption=[{
          time:''
        },
        ]
      },
      // 餐厅关闭商品
      addProHandleClose(){
        this.flag = false
        this.addFlow = false
      },
      // 表头设置
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return this.utils.tableHeaderColor({
          row,
          column,
          rowIndex,
          columnIndex
        });
      },
      cellStyle({ row, rowIndex }) {
        return this.utils.cellStyle({
          row,
          rowIndex
        });
      }
    }
  }
</script>
<style scoped lang="less">
  .tab{
    margin-top: 1.8rem;
    display: flex;
    align-items: center;
    >div{
      margin-right: 2rem;
      width: 11rem;
      height: 4rem;
      border-radius: 4px;
      color: #fff;
      font-size: 1.4rem;
      text-align: center;
      line-height: 4rem;
      cursor: pointer;
      background: #D9D9D9;
    }
    .active{
      background: #246DEB;
    }
  }
  .center_table{
    margin-top: 2rem;
    background: #fff;
    padding: 2rem;
    box-sizing: border-box;
    .top{
      display: flex;
      justify-content: space-between;
      margin-bottom: 2rem;
      .input_condition{
        display: flex;
        align-items: center;
        ::v-deep .el-input{
          width: 22rem;
          margin-right: 2rem;
        }
        ::v-deep .el-select{
          margin-left: 2rem;
        }
        .restClass{
          padding: 0 1rem;
          height: 4rem;
          line-height: 4rem;
          color: #fff;
          font-size: 1.4rem;
          border-radius: 4px;
          text-align: center;
          background: #246DEB;
          cursor: pointer;
          margin-right: 2rem;
          box-sizing: border-box;
        }
       
        .btnen{
          box-sizing: border-box;
          width: 10rem;
          height: 4rem;
          line-height: 4rem;
          color: #fff;
          font-size: 1.4rem;
          border-radius: 4px;
          text-align: center;
          background: #246DEB;
          margin-right: 2rem;
          cursor: pointer;
        }
        .exportBnts{
          margin-left: 2rem;
        }
      }
    }
    .right_btn{
      display: flex;
      align-items: center;
      >div{
        width: 11rem;
        height: 4rem;
        border-radius: 4px;
        font-size: 1.4rem;
        text-align: center;
        line-height: 4rem;
        cursor: pointer;
        border-radius: 4px;
        margin-left: 2rem;
        &:nth-child(1){
          border: 1px solid #246DEB;
          color: #246DEB;
        }
      }
    }
    .input_div{
      div{
        width: 11rem;
        height: 4rem;
        border-radius: 4px;
        border: 1px solid #246DEB;
        text-align: center;
        line-height: 4rem;
        color: #246DEB;
        cursor: pointer;
        font-size:1.4rem;
      }
    }
  }
  .tab_del{
    color: #E74C3C;
    font-size: 1.4rem;
    cursor: pointer;
  }
  .paixu{
    ::v-deep .el-input{
      width: 6rem;
    }
    ::v-deep .el-input input{
      border-radius: 4px;
      background: #F7F7FA;
      color: #000;
      width: 6rem;
      text-align: center;
      padding: 0 3px;
    }
  }
  .caozuo{
    span{
      color: #246DEB;
      font-size: 1.4rem;
      margin-right: 2rem;
      cursor: pointer;
      &:last-child{
        color: #E74C3C;
      }
    }
  }
::v-deep .el-table__header th,::v-deep .el-table td{
  text-align: left !important;
}
.btn{
          box-sizing: border-box;
          padding: 0 1rem;
          height: 4rem;
          line-height: 4rem;
          color: #fff;
          font-size: 1.4rem;
          border-radius: 4px;
          text-align: center;
          background: #fff;
          border: 1px solid #E5E5EA;
          color: #333;
          margin-right: 2rem;
          cursor: pointer;
        }
.addDk{
  border-top: 1px solid #E5E5EA;
}

.addBtns{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3.8rem;
  >div{
    width: 10rem;
    height: 4rem;
    border-radius: 4px;
    line-height: 4rem;
    text-align: center;
    font-size: 1.4rem;
    color: #fff;
    cursor: pointer;
    &:nth-child(1){
      margin-right: 2rem;
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246DEB;
    }
  }
}
::v-deep .el-dialog__body{
  border-top: 1px solid #E5E5EA;
}
.restaurant{
  padding: 2rem 2rem 2rem 2rem;
  box-sizing: border-box;
}
.dateFlex{
  display: flex;
  align-items: center;
  ::v-deep .el-checkbox-group{
    height: 40px;
    margin-left: 1rem;
  }
  ::v-deep .is-checked .el-checkbox__inner{
    background: #4ECB73 !important;
    border-color: #4ECB73 !important;
  }
  ::v-deep .is-checked .el-checkbox__label{
    color: #000;
  }
}
.form_time{
  margin-left: 12rem;
  margin-top: 2rem;
}
::v-deep .el-upload {
    border-radius: 4px;
    border: 1px solid #E5E5EA;
    background: #FFF;
    width: 10rem;
    height: 7rem;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width:100%;
    height: 100%;
    line-height: 7rem;
    text-align: center;
  }
  .avatar {
    width:100%;
    height: 100%;
    display: block;
  }
  .mask_notes ::v-deep .el-textarea textarea{
    resize: none;
    height: 8rem;
  }
  .indicating{
    cursor: pointer;
    img{
      width: 1.8rem;
      height: 1.8rem;
    }
    span{
      font-size: 1.4rem;
      color: #246DEB;
      margin-left: 1rem;
    }

  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .center_form{
    max-width: 56.6rem;
    padding: 4rem;
    box-sizing: border-box;
    background: #fff;
    border-radius: 4px;
    margin: 10rem 0 0 50rem;
  }
  .form_btns{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 4rem;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
      &:nth-child(1){
        background: #D9D9D9;
        margin-right: 2rem;
      }
      &:nth-child(2){
        background: #246DEB;
      }
    }
  }
  .pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}
.methodsFlex{
  display: flex;
  flex-direction: column;
  img{
    width: 30rem;
    height: 30rem;
    margin-top: 2rem;
    margin-left: 2rem;
  }
}
.imgs_times{
  margin-left: 2rem;
}
.names_times{
  &:nth-child(n+2){
    margin-top: 2rem;
  }
}
.flexs_upload{
    display: flex;
  }
  .orderbtns{
    width: 10rem !important;
  }
</style>
<style>
.el-time-spinner__wrapper{
  width: 50% !important;
}
.el-time-spinner__wrapper:nth-child(3){
    display: none !important;
}
</style>